var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgN1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 11,
    viewBox: "0 0 13 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7309 5.40988L6.82435 0.120466C6.78182 0.0822787 6.73131 0.0519824 6.6757 0.0313112C6.62009 0.0106401 6.56047 0 6.50027 0C6.44006 0 6.38045 0.0106401 6.32484 0.0313112C6.26923 0.0519824 6.21872 0.0822787 6.17619 0.120466L0.26959 5.40988C0.0975112 5.56409 0 5.77356 0 5.99202C0 6.44566 0.411555 6.81448 0.917752 6.81448H1.5401V10.5888C1.5401 10.8162 1.74516 11 1.99898 11H5.58252V8.12141H7.18858V11H11.0016C11.2554 11 11.4604 10.8162 11.4604 10.5888V6.81448H12.0828C12.3266 6.81448 12.5603 6.72838 12.7324 6.57288C13.0894 6.25161 13.0894 5.73115 12.7309 5.40988Z",
    fill: "url(#paint0_linear_764_3)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_764_3",
    x1: 6.5,
    y1: 0,
    x2: 6.5,
    y2: 11,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E87D00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E22201"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgN1);
export default __webpack_public_path__ + "static/media/n1.0229cbd601e218216c2024020d71e200.svg";
export { ForwardRef as ReactComponent };